import { Progress } from "antd";
import styles from "./style.module.scss";

const STROKE_WIDTH_MAP = {
  primary: 12,
  default: 4,
} as const;

export interface VLProgressBarProps {
  maxItems: number;
  itemLength: number;
  color?: "danger" | "warning" | "success" | "default";
  isActive?: boolean;
  type?: "primary" | "default";
}

export default function VLProgressBar({
  itemLength,
  maxItems,
  color,
  isActive,
  type,
}: VLProgressBarProps) {
  const percent = (itemLength / maxItems) * 100;
  const colorMap = {
    danger: "var(--new-primary-red-500)",
    warning: "var(--new-primary-orange-500)",
    success: "var(--new-primary-green-500)",
  };

  const strokeColor = color
    ? colorMap[color as keyof typeof colorMap]
    : undefined;

  const strokeWidth = STROKE_WIDTH_MAP[type ?? "default"];

  const status = isActive ? "active" : "normal";

  return (
    <Progress
      className={styles.progress}
      strokeColor={strokeColor}
      percent={percent}
      showInfo={false}
      status={status}
      strokeWidth={strokeWidth}
    />
  );
}
